import React from 'react'
import styled from '@emotion/styled'

const Svg = styled('svg')``

type Props = {
    title?: string
    className?: string
}

export const SaveIcon = ({ title, className }: Props) => {
    return (
        <Svg viewBox="0 0 20 20" className={className} aria-hidden="true">
            <title>{title}</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="side_bar" data-name="side bar">
                    <g id="DARK_minutes" data-name="DARK minutes">
                        <g id="saved">
                            <path
                                id="save_icon"
                                data-name="save icon"
                                d="M18.33,20H1.67A1.69,1.69,0,0,1,0,18.33V1.67A1.69,1.69,0,0,1,1.67,0H15.3a.67.67,0,0,1,.47.19l4,4A.67.67,0,0,1,20,4.7V18.33A1.69,1.69,0,0,1,18.33,20ZM1.67,1.31a.35.35,0,0,0-.36.36V18.33a.35.35,0,0,0,.36.36H18.33a.35.35,0,0,0,.36-.36V5L15.2,1.49V7.73a.65.65,0,0,1-.66.65H4.44a.65.65,0,0,1-.65-.65V1.31ZM10,16.72a3.19,3.19,0,1,1,3.18-3.18A3.19,3.19,0,0,1,10,16.72Zm0-5a1.87,1.87,0,1,0,1.87,1.87A1.85,1.85,0,0,0,10,11.67ZM5.1,7.07h8.79V1.31H5.1Z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </Svg>
    )
}
